import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

const Section = ({ title, children, testId }) => (
  <div data-testid={testId} className="space-y-2">
    <h2 className="text-sm font-black uppercase tracking-wide text-cyan-400">{title}</h2>
    <div className="text-sm text-slate-400 leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10 space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2.5">
          <ShieldCheck className="w-6 h-6 text-cyan-400" />
          <h1 className="text-2xl font-black uppercase tracking-tight text-slate-100">Politique de confidentialité</h1>
        </div>
        <Link data-testid="privacy-back-link" to="/" className="text-xs font-mono uppercase tracking-widest text-slate-400 border border-slate-700 rounded-md px-3 py-2 hover:bg-slate-800/60 flex items-center gap-1.5">
          <ArrowLeft className="w-3.5 h-3.5" /> Retour
        </Link>
      </div>
      <p className="text-xs text-slate-500 font-mono uppercase tracking-widest">Dernière mise à jour : Septembre 2026</p>

      <Section title="Responsable du traitement" testId="privacy-section-responsable">
        <p>L'application "Inspection des Fronts de Carrière" est éditée et exploitée par l'usine (Lafarge) pour le suivi de la sécurité de ses fronts de carrière. Pour toute question relative à cette politique ou à l'exercice de vos droits, contactez :</p>
        <p className="font-semibold text-slate-300" data-testid="privacy-contact-email">khalifa.belkhiter@lafarge.com</p>
      </Section>

      <Section title="Données collectées" testId="privacy-section-donnees">
        <ul className="list-disc list-inside space-y-1">
          <li><b>Identité professionnelle</b> : nom, prénom, adresse email et photo de profil, transmis par votre compte Google lors de la connexion (accès autorisé uniquement pour les comptes déjà enregistrés par un administrateur).</li>
          <li><b>Données d'affectation</b> : rôle (Inspecteur, Responsable, Administrateur) et site (usine) d'affectation.</li>
          <li><b>Données d'inspection</b> : réponses au questionnaire, anomalies constatées, actions correctives, commentaires et horodatages liés à votre activité dans l'application.</li>
          <li><b>Photographies</b> prises lors des inspections, stockées sur Google Drive (compte de l'entreprise).</li>
        </ul>
        <p>Aucune donnée bancaire, de géolocalisation précise ou de donnée sensible au sens du RGPD n'est collectée.</p>
      </Section>

      <Section title="Finalités du traitement" testId="privacy-section-finalites">
        <ul className="list-disc list-inside space-y-1">
          <li>Authentification et contrôle d'accès basé sur les rôles.</li>
          <li>Suivi et pilotage en temps réel de la sécurité des fronts de carrière.</li>
          <li>Traçabilité des décisions de suspension et de remise en exploitation (journal d'audit).</li>
          <li>Amélioration continue de la sécurité au travail.</li>
        </ul>
      </Section>

      <Section title="Base légale" testId="privacy-section-base-legale">
        <p>Le traitement repose sur l'intérêt légitime de l'employeur en matière de sécurité au travail et sur l'exécution du contrat de travail des utilisateurs.</p>
      </Section>

      <Section title="Hébergement et sous-traitants" testId="privacy-section-hebergement">
        <p>Les données sont exclusivement stockées sur Google Sheets (base de données) et Google Drive (photos, QR codes), au sein du compte Google professionnel de l'entreprise. Aucune donnée n'est transmise à des tiers à des fins commerciales ou publicitaires.</p>
      </Section>

      <Section title="Durée de conservation" testId="privacy-section-conservation">
        <p>Les données sont conservées pendant toute la durée d'activité du site concerné, augmentée des durées nécessaires à la traçabilité réglementaire de la sécurité minière. Le responsable du traitement peut être contacté pour toute demande de purge anticipée.</p>
      </Section>

      <Section title="Vos droits" testId="privacy-section-droits">
        <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité sur vos données personnelles. Pour exercer ces droits, contactez :</p>
        <p className="font-semibold text-slate-300">khalifa.belkhiter@lafarge.com</p>
        <p>Vous disposez également du droit d'introduire une réclamation auprès de l'autorité de contrôle compétente (en France, la CNIL) si vous estimez que vos droits ne sont pas respectés.</p>
      </Section>

      <Section title="Sécurité" testId="privacy-section-securite">
        <p>L'accès à l'application est réservé aux comptes déjà autorisés par un administrateur (connexion via Google). La session est protégée par un cookie technique sécurisé (aucun cookie publicitaire ou de suivi tiers n'est utilisé).</p>
      </Section>
    </div>
  );
}
